module.exports = __webpack_public_path__ + "img/撤销2.e5982bce.svg";